import { useMemo, useState } from 'react';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles } from '@/mocks/articles';

const tabs = [
  { key: 'all', label: '全部' },
  { key: 'variety', label: '综艺资讯' },
  { key: 'news', label: '娱乐新闻' },
];

export default function LatestNews() {
  const [tab, setTab] = useState('all');
  const [visible, setVisible] = useState(5);

  const sorted = useMemo(
    () => [...articles].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()),
    [],
  );

  const filtered = useMemo(
    () => (tab === 'all' ? sorted : sorted.filter((a) => a.category === tab)),
    [tab, sorted],
  );

  const list = filtered.slice(0, visible);
  const hasMore = filtered.length > visible;

  const handleTab = (key: string) => {
    setTab(key);
    setVisible(5);
  };

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-200/60">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <SectionHeading
            icon="ri-fire-line"
            title="最新资讯"
            subtitle="综艺动态与娱乐新闻，第一时间送达"
          />
          {/* Tabs */}
          <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 w-fit">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => handleTab(t.key)}
                className={`px-4 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  tab === t.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-primary-700'
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3 md:gap-4 mt-2">
          {list.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="flex justify-center mt-8">
          {hasMore ? (
            <button
              type="button"
              onClick={() => setVisible((v) => v + 4)}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-add-line" />
              加载更多
            </button>
          ) : (
            <span className="text-sm text-foreground-500">已经到底啦，去分类页看看更多内容吧</span>
          )}
        </div>
      </div>
    </section>
  );
}